import React from "react";

/**
 * @author
 * @function AboutUs
 **/

export const AboutUs = (props) => {
  return (
    <div className="text-black min-h-screen py-12 px-6 md:px-20">
      <div className="max-w-5xl mx-auto">
        <h1 className="text-4xl md:text-5xl font-bold mb-8 text-black">
          About WRISTLINK
        </h1>
        <p className="text-lg leading-8 mb-6">
          WRISTLINK is a private, trader-to-trader platform created exclusively
          for trusted professionals in the luxury watch industry.
        </p>
        <p className="text-lg leading-8 mb-6">
          Founded by two brothers with a lifelong passion for horology,
          WRISTLINK was born out of a shared mission: to build a secure,
          transparent, and reliable space where vetted watch traders can
          connect, trade, and grow their businesses with confidence.
        </p>
        <p className="text-lg leading-8 mb-6">
          As avid watch lovers turned industry insiders, we understood the
          challenges traders face—limited trust, unreliable networks, and
          inefficient systems. So we set out to change that.
        </p>
        <p className="text-lg leading-8 mb-6">
          WRISTLINK brings together the world’s most reputable traders, offering
          real-time access to premium timepieces from iconic brands like Rolex,
          Patek Philippe, Audemars Piguet, Richard Mille, and more. Every member
          is verified. Every listing is monitored. Every trade is built on
          trust.
        </p>

        <h2 className="text-3xl font-semibold mt-10 mb-6 text-black">
          Why WRISTLINK?
        </h2>

        <ul className="space-y-6">
          <li className="flex items-center">
            <img
              src="https://cdn-icons-png.flaticon.com/128/12892/12892185.png"
              alt="Built by Traders"
              className="w-10 h-10 mr-4"
            />
            <span className="text-lg">
              Built by Traders, for Traders: We know the market because we live
              it.
            </span>
          </li>
          <li className="flex items-center">
            <img
              src="https://cdn-icons-png.flaticon.com/128/11946/11946204.png"
              alt="Private Network"
              className="w-10 h-10 mr-4"
            />
            <span className="text-lg">
              Private Network: No public access. No retail buyers. Just real
              professionals.
            </span>
          </li>
          <li className="flex items-center">
            <img
              src="https://cdn-icons-png.flaticon.com/128/9918/9918743.png"
              alt="Verified Members"
              className="w-10 h-10 mr-4"
            />
            <span className="text-lg">
              Verified Members: Every trader is vetted for credibility and
              integrity.
            </span>
          </li>
          <li className="flex items-center">
            <img
              src="https://cdn-icons-png.flaticon.com/128/12141/12141658.png"
              alt="Live Inventory"
              className="w-10 h-10 mr-4"
            />
            <span className="text-lg">
              Live Inventory: Post and browse listings in real time, with zero
              hassle.
            </span>
          </li>
        </ul>

        <p className="text-xl mt-10 font-medium text-black">
          Join the WRISTLINK community—where trust meets trade.
        </p>
      </div>
    </div>
  );
};
